import React from 'react'
import './DocTypeSelector.css'

export type DocType = 'api' | 'webview'

interface DocTypeSelectorProps {
    currentType: DocType
    onTypeChange: (type: DocType) => void
}

const DocTypeSelector: React.FC<DocTypeSelectorProps> = ({ currentType, onTypeChange }) => {
    return (
        <div className="doc-type-selector">
            <button
                className={`doc-type-button ${currentType === 'api' ? 'active' : ''}`}
                onClick={() => onTypeChange('api')}
            >
                <span className="doc-type-icon">🔌</span>
                <span className="doc-type-label">API</span>
            </button>
            <button
                className={`doc-type-button ${currentType === 'webview' ? 'active' : ''}`}
                onClick={() => onTypeChange('webview')}
            >
                <span className="doc-type-icon">📱</span>
                <span className="doc-type-label">Webview</span>
            </button>
        </div>
    )
}

export default DocTypeSelector
